<template>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="800px"
    >
      <template v-slot:activator="{ on, attrs }">
       
       <v-btn 
       v-bind="attrs"
          v-on="on"
          data-cy="add-opcion-input"
       @click="opcionEdit" 
   
       >
       <v-icon left>mdi-plus</v-icon>
        AGREGAR LINK
       </v-btn>

      
       
      </template>


      <v-card>

 <!-- INICIO DIALOG DATA -->

 <div class="my-2">
      <v-btn @click="dialogData = true">check data</v-btn>
    </div>

     <v-dialog
      v-model="dialogData"
    >
      <v-card>
 
        <v-card-title>PRINCIPAL </v-card-title>

       <v-card-text class="pprint">{{ principal }}</v-card-text>

       <v-card-title>OPCION </v-card-title>

<v-card-text class="pprint">{{opcion}}</v-card-text>

        
        
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn outlined color="info" text @click="dialogData = false">CLOSE</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
 


<!-- FIN DIALOG DATA -->
      






        <v-card-title>
         Registrar Link
        </v-card-title>
        
<v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                

                <v-card-text>
               <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    >
   
   

            
 <v-text-field
           v-model="opcion.link"
           :rules="urlRules"
           label="Link"
           required
           @blur="perderFocoLink($event)"
         ></v-text-field>


         
    <v-text-field
           v-model="opcion.descripcion"
           label="Descripcion"
           :counter="2"
           :rules="textRules"
           required
         ></v-text-field>



    <v-text-field
           v-model="opcion.linkPhoto"
           label="Link_photo"
           disabled

           v-show="false"
         ></v-text-field>

          <v-text-field
           v-model="opcion.linkVideo"
           label="LinkVideo"
           disabled
            v-show="false"
         ></v-text-field>
   
   
  
   			
    <v-text-field
           v-model="opcion.tipo"
           label="Tipo"
           :counter="3"
           
           disabled

            v-show="false"
         ></v-text-field>
   
   
    <v-text-field
           v-model="opcion.observacion"
           label="Observación"
           
         ></v-text-field>


         <v-avatar class="ma-3"
              :style="{ width: '125px', height: '125px' }"
              tile >
         
              <img :src="server_url +'api/imagenes_base/get_imagenes_base/'+opcion.linkPhoto" style="height:100px" v-if="opcion.linkPhoto"/> 

    </v-avatar>
   

   
   
   

   
  
   

 <v-row no-gutters>
      
      <v-col>
      </v-col>

      <v-col order="last">
        
      </v-col>
     
    </v-row>


      
      <v-btn
        :disabled="!valid"
        color="success"
        class="mr-4"
        @click="registrarOpcion"
      >
        Registrar
      </v-btn>

      <v-btn
        color="error"
        class="mr-4"
        @click="dialog = false"
      >
        Cancelar
      </v-btn>
  
    </v-form> 
            </v-card-text>
               


              </v-col>
              
            </v-row>
          </v-container>
        </v-card-text>


        <!-- <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn    
            color="green darken-1"
            text
            @click="dialog = false"
          >
            Disagree
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="dialog = false"
          >
            Agree
          </v-btn>
        </v-card-actions>  -->
      </v-card>




    </v-dialog>

</template>




<script>

import opcionService from "@/services/opcionService.js";

import imagenesBaseService from "@/services/imagenesBaseService.js";

import { http } from "@/services/config";

//import  {storage} from "../../firebase"
//import  {uploadBytes} from "firebase/storage"
//import {ref, getDownloadURL, uploadBytesResumable } from 'firebase/storage';
//import  CloudImage  from '../CloudImage.vue'

 
export default {

   props: {
   principalData: {
      type: Object, // Tipo de dato correspondiente al objeto del autor
      default: () => ({}) // Valor por defecto, un objeto vacío si no se proporciona
    },
    principal: {
      type: Object, // Tipo de dato correspondiente al objeto del autor
      default: () => ({}) // Valor por defecto, un objeto vacío si no se proporciona
    }
  },
 
  data: vm => ({
  
  dialogData:false,
  valid: true,
    dialog:false,
    errors: "",
    showError: false,
    opcions: [],
    buscador:'',
     refreshImage: false,
     selectedFile:null,
     UploadValue:0,
     picture:null,
     file: null,


     
      server_url: "",
      valid: false,
      archivo: null,
      fileData: {
        downloadUri: "",
      },
    opcion:{

descripcion:'',
link:'',
linkPhoto:'',
tipo:'',
observacion:'',
id:'',
principal:{}

          
        },
  
    rules: {
                  required: value => !!value || 'Campo Requerido',
                  min: v => v.length >= 5 || 'Minimo 5 caracteres',
                  emailMatch: () => (`The email and password you entered don't match`),
                },
        	messages:undefined,
        
        
        
         textRules: [
              (v) => !!v || "Campo es requerido",
              (v) => (v && v.length >= 1) || "Debe contener al menos 3 caracteres",
            ],

            urlRules: [
  (v) => !!v || "URL es requerida",
  (v) => /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i.test(v) || "URL debe ser válida",
],
        
            emailRules:  [
              (v) => !!v || "Correo es requerido",
              (v) => /.+@.+\..+/.test(v) || "Correo debe ser valido",
            ],
             numberRules: [
              (v) => (v >= 0) || "Valor debe ser mayor o igual a 0",
            ],
  }),
  components:{
    //  CloudImage
  },
  mounted() {
    //this.listar();
    // console.log('Código del autor:', this.opcionData);

   //  this.opcion=this.opcionData;

   this.server_url = http.defaults.baseURL;
  },
  methods: {


    async recaptcha() {
  try {
    
    await this.$recaptchaLoaded();

    const token = await this.$recaptcha('login');

    
    return token;
  } catch (error) {
    console.error('Error al ejecutar reCAPTCHA:', error);
    throw error; 
  }
}
,


    perderFocoLink(e){

      this.opcion.observacion=e.target.value;

      const url = e.target.value; // Captura el valor del input
    const domain = new URL(url).hostname; // Obtiene el hostname de la URL (e.g., 'www.facebook.com')
    
    // Extrae el nombre de la red social a partir del dominio (quita 'www.' y '.com')
    let socialNetwork = domain.replace("www.", "").split(".")[0]; 
    
    // Capitaliza la primera letra
    socialNetwork = socialNetwork.charAt(0).toUpperCase() + socialNetwork.slice(1);

    console.log(socialNetwork); // Resultado: 'Facebook'


      this.opcion.descripcion=socialNetwork;


  imagenesBaseService.obtenerImgPorDescripcion(this.opcion.descripcion)
    .then(response => {
      if (response.data.status) {
       this.opcion.linkPhoto=response.data.imagenesBase.linkPhoto;
       console.log(response.data.imagenesBase)
      } else {
        console.error('Error: File not found');
      }
    })
    .catch(error => {
      console.error('Error al obtener la URL DE LA imagen:', error);
    });






    },

    opcionEdit(){
      console.log(this.principalData);
      //Al momento inicial se carga el id correspondiente.
      this.opcion.principal.id=this.principalData.id;
    },
    listar() {
      opcionService
        .listar()
        .then((resposta) => {
          console.log(resposta.data);
          this.opcions = resposta.data;
         
        })
        .catch((e) => {
          this.errors = e.response.data.errors;
        });
    }, 
    registrarOpcion: async function(){



      try {
      const tokenr = await this.recaptcha(); // Espera hasta que recaptcha() termine


      console.log('Token obtenido:2502');
      this.opcion.recaptcha=tokenr;


    } catch (error) {
    console.error('Error en reCAPTCHA:', error);
  }






            if (this.$refs.form.validate()) {

      

    opcionService.save(this.opcion).then(
        response =>{
         //  console.log('success');

           // console.log(response);

            alert("Registrado correctamente!!");

            this.limpiar();
        }).catch((errors) =>{
         
           console.log('error');
            console.log(errors);

           
        })
       // console.log(res);


            }


      //console.log(opcion);
            this.$emit('opcionEdit',this.opcion);
            this.dialog=false;
        },
    validate(){
      if (this.$refs.form.validate()) {
        this.snackbar = true;
      }
    },
    reset() {
    //  this.$refs.form.reset();
      this.limpiar();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    }
    ,
    limpiar(){

     
		this.opcion={
				descripcion:'',
        link:'',
				linkPhoto:'',
				tipo:'',
				observacion:'',
				id:'',
        principal:{}
	}
  },
           upload: function() {

            const file2 = this.$refs.myfile.files[0];
      const storageRef = ref(storage, `folder/${file2.name}`);

     // const storageRef = ref(storage, 'folder/myfile.gif');
      uploadBytes(storageRef,this.$refs.myfile.files[0]).then((snapshot)=> {
        console.log("uploaded")
      })
    },
    upload3: function() {
  const file = this.file;

console.log(file);
 /* if (file) {
    const storageRef = ref(storage, `folder/${file.name}`);

    uploadBytes(storageRef, file).then((snapshot) => {
      console.log("Archivo subido correctamente");
      // Aquí podrías hacer algo después de la subida exitosa, si es necesario
    }).catch((error) => {
      console.error("Error al subir el archivo:", error);
    });
  } else {
    console.error("No se ha seleccionado ningún archivo");
  }*/
}
          ,
    async upload2() {
      const file = this.$refs.myfile.files[0];
      const storageRef = ref(storage, `folder/${file.name}`);

      // Sube el archivo a Firebase Storage
      const uploadTask = uploadBytesResumable(storageRef, file);

      uploadTask.on('state_changed',
        (snapshot) => {
          // Observa el progreso, si es necesario
        },
        (error) => {
          console.error('Error al subir el archivo:', error);
        },
        () => {
          // Subida exitosa, obtén la URL de descarga
          getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
            // Actualiza opcion.link_photo con la URL de la imagen
            console.log(downloadURL);
            this.opcion.linkPhoto = downloadURL;

            // Activa el refresco del componente CloudImage
            this.refreshImage = !this.refreshImage;
          });
        }
      );
    },
    onFileSelected(event){
        this.selectedFile =event.target.files[0];
    },
    onUpload() {
    const storageRef = firebase.storage().ref(`/folder/${this.selectedFile.name}`);
    const task = storageRef.put(this.selectedFile);

    task.on('state_changed',snapshot=>{
      let percentaje= (snapshot.bytesTransferred/snapshot.totalBytes)*100;
      this.UploadValue=percentaje;
    },error=>{console.log(error.message)},
    ()=>{this.UploadValue=100;
            task.snapshot.ref.getDownloadURL.then((url)=>{
              this.picture=url;
              console.log(this.picture);
            });
    });
    
    },
     handleFileChange(event) {
      const file = this.file;
      if (file) {
        console.log(file.name);
        this.opcion.link_photo = 'folder/'+file.name;

        console.log(this.opcion.linkPhoto);


       const file2 = this.$refs.myfile.files[0];
      const storageRef = ref(storage, `folder/${file2.name}`);

     // const storageRef = ref(storage, 'folder/myfile.gif');
      uploadBytes(storageRef,this.$refs.myfile.files[0]).then((snapshot)=> {
        console.log("uploaded")
      })



      }






    }



    ,
    uploadFile: function () {
      if (this.archivo) this.submitFile();
      else this.removeFile();
    },
    submitFile() {
      console.log(this.archivo);



      const storageRef = ref(storage, `folder/${this.archivo.name}`);

     // const storageRef = ref(storage, 'folder/myfile.gif');
      uploadBytes(storageRef,this.archivo).then((snapshot)=> {
        console.log("uploaded")
      })



      console.log('submit');

      this.opcion.linkPhoto = 'folder/'+this.archivo.name;
    },
    removeFile() {
        this.fileData = { downloadUri: "" };
      
        this.archivo=null;
  
    },

    

  
  
  },//fin methos

    watch: {
      
    },




}
    
  
</script>




<style scoped>

.pprint {
  white-space:pre-wrap;
  word-wrap:break-word;
}
</style>